var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-save-btn"},[(_vm.isMobile)?_c('img',{staticClass:"fixed-save-btn__close",attrs:{"src":require("@/assets/images/close-fixed-btn.svg")},on:{"click":_vm.close}}):_vm._e(),_c('span',{staticClass:"fixed-save-btn__txt"},[_vm._v("\n        Чтобы изменить данные, не забудьте их сохранить\n    ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }